import { useEffect, useState } from "react";

/**
 * Tracks `window.matchMedia` for responsive layout (`change` avoids polling).
 */
export function useMatchMedia(query: string): boolean {
  const [matches, setMatches] = useState(
    (): boolean =>
      typeof window !== "undefined" && typeof window.matchMedia === "function"
        ? window.matchMedia(query).matches
        : false
  );

  useEffect(() => {
    if (typeof window.matchMedia !== "function") return;
    const mq = window.matchMedia(query);
    const onChange = (): void => setMatches(mq.matches);
    onChange();
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}
